import { render, staticRenderFns } from "./SurgeCalculation.vue?vue&type=template&id=3f0a8006"
import script from "./SurgeCalculation.vue?vue&type=script&lang=js"
export * from "./SurgeCalculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports